import * as React from "react";
import "./GeneralNotifications.css";
import { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import SearchIcon from "@mui/icons-material/Search";

import { resources } from "../Resourses/Resources";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { InputAdornment, Button } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DeleteIcon from '@mui/icons-material/Delete';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ViewGeneralNotifications = () => {
  const [open, setOpen] = useState(false);
  const [genData, setGenData] = useState([]); // Original data from API
  const [filteredData, setFilteredData] = useState([]); // Filtered data for display
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [viewFile, setViewFile] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [fileUrl, setFileUrl] = useState("");

  // Fetch General Notifications Data
  const getGeneralNotificationsDetails = async () => {
    try {
      const res = await axios.get(
        resources.APPLICATION_URL + `getAllGeneralNotifications`
      );
      console.log("Fetched Data:", res.data);
      if (res.status === 200) {
        setGenData(res.data);
        setFilteredData(res.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Apply all filters (search + date range)
  const applyFilters = () => {
    let filtered = [...genData];

    // Apply search filter if searchQuery exists
    if (searchQuery) {
      filtered = filtered.filter(
        (item) =>
          item.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.fileName.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.startDate.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Apply date range filter if dates exist
    if (fromDate || toDate) {
      filtered = filtered.filter((item) => {
        const itemDate = new Date(item.startDate);
        const from = fromDate ? new Date(fromDate) : null;
        const to = toDate ? new Date(toDate) : null;

        if (from && to) {
          return itemDate >= from && itemDate <= to;
        } else if (from) {
          return itemDate >= from;
        } else if (to) {
          return itemDate <= to;
        }
        return true;
      });
    }

    setFilteredData(filtered);
  };

  // Handle search input change
  const handleSearch = (query) => {
    setSearchQuery(query);
    applyFilters();
  };

  // Handle date filter button click
  const handleDateFilter = () => {
    // Reset filtered data to original before applying new filters
    setFilteredData(genData);
    applyFilters();
  };

  // Reset all filters
  const resetFilters = () => {
    setFromDate("");
    setToDate("");
    setSearchQuery("");
    setFilteredData(genData);
  };

  // Fetch data on component mount
  useEffect(() => {
    getGeneralNotificationsDetails();
  }, []);

  // View File Handler
  const handleViewFile = async (filePath) => {
    setFileUrl(filePath);
    setOpen(true);
    if (!filePath) return;

    try {
      const response = await axios.get(
        resources.APPLICATION_URL +
          `getFilePathtoConvertBase64?filePath=${encodeURIComponent(filePath)}`
      );

      if (response.data) {
        handleClickOpen();
        setViewFile(response.data);
        const base64Data = response.data?.base64 || response.data;
        const byteCharacters = atob(base64Data);
        const byteNumbers = Array.from(byteCharacters).map((char) =>
          char.charCodeAt(0)
        );
        const byteArray = new Uint8Array(byteNumbers);
        const pdfBlob = new Blob([byteArray], { type: "application/pdf" });
  
        const blobUrl = URL.createObjectURL(pdfBlob);
        window.open(blobUrl, '_blank');
      }
  
    } catch (error) {
      console.error("Error fetching file:", error);
    }
 
  };
  const onClose = () => {
    setFileUrl("");
  };

  const handleNotidel = async (sno) => {
    try {
      let notiDel = await axios.delete(resources.APPLICATION_URL + `deleteGeneralNotificationByid?sno=${sno}`)
      console.log(notiDel)
      getGeneralNotificationsDetails()
    } catch (error) {
      console.log('notiDel call error', error)
    }
  }

  return (
    <div className="search_main">
      {/* Search Section */}
      <div className="searchDiv">
        {/* Search Bar */}
        <div>
          <input
            type="text"
            placeholder="Search by description, file name or date..."
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>

        {/* Date Range Filter */}
        <div className="fromDateToDateDiv">
          <div className="fromDateToDateInput">
            <label>From Date</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>
          <div className="fromDateToDateInput">
            <label>To Date</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleDateFilter}
              style={{ marginLeft: "10px" }}
            >
              Filter
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={resetFilters}
              style={{ marginLeft: "10px" }}
            >
              Reset
            </Button>
          </div>
        </div>
      </div>

      {/* Display Table */}
      <table className="tableStylings" style={{ marginTop: "20px" }}>
        <thead>
          <tr>
            <th>S.No</th>
            <th>Date</th>
            <th>Description</th>
            <th>File Name</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.length > 0 ? (
            filteredData.map((items, index) => {
              console.log("itemssssssssss", items)
              return <tr key={index}>
                <td>{index + 1}</td>
                <td>{items.startDate}</td>
                <td>{items.description}</td>
                <td>{items.fileName}</td>
                <td>
                  <RemoveRedEyeOutlinedIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => handleViewFile(items.filePath)}
                  />
                  <DeleteIcon sx={{fontSize: '18px', marginLeft: '6px'}} onClick={() => handleNotidel(items.sno)}/>
                </td>
              </tr>
})
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: "center", padding: "10px" }}>
                No Data Found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* File View Dialog */}
      <Dialog
        fullScreen
        // open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            width: "100%",
            height: "100%",
            margin: 0,
            padding: 0,
            maxHeight: "100vh",
          },
        }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        {viewFile && (
          <iframe
            src={`data:application/pdf;base64,${viewFile}`}
            width="100%"
            height="100%"
          />
        )}
      </Dialog>
      {/* <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth="md"
        // fullWidth
      > */}
        {/* <DialogContent>
            {fileUrl?.startsWith("JVBER") ? (
              <iframe
                src={`data:application/pdf;base64,${fileUrl}`}
                title="PDF Viewer"
                width="400px"
                height="400px"
                // className="w-full h-full border-none"
              />
            ) : (
              <img
                src={`data:image/png;base64,${fileUrl}`}
                alt="Preview"
                className="max-w-full max-h-full"
              />
            )}
            <div className="mt-4 flex justify-end">
              <Button
                onClick={onClose}
                className="bg-red-500 text-white px-4 py-2 rounded-lg"
              >
                Close
              </Button>
            </div>
        </DialogContent> */}
      {/* </Dialog> */}
    </div>
  );
};

export default ViewGeneralNotifications;
